module.exports = __webpack_public_path__ + "static/media/office_1.b04eb3c6.jpg";